// extracted by mini-css-extract-plugin
module.exports = {"link":"KlLinkDark_link__6p--8"};